function AdMakerLogo() {
  return (
    <img
      style={{ display: 'block', verticalAlign: 'top' }}
      src="https://pastatic.picsart.com/cms-pastatic/1a360a20-6542-4847-8266-c5af8f340912.svg"
      width={24}
      height={24}
    />
  );
}
export default AdMakerLogo;
